<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <!-- <el-row>
            <el-col :span="6">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.ridgepoleId"
                  placeholder="请选择楼栋"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="单元名称"
                prop="ridgepoleId"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.unitId"
                  placeholder="请选择单元"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="楼层名称" prop="name" style="width: 80%">
                <el-select
                  clearable filterable
                  v-model="searchForm.floorId"
                  placeholder="请选择楼层"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="房间名称" prop="name" style="width: 80%">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入房间名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item label="房屋信息" prop="keyword" style="width: 80%">
                <el-input
                  v-model="searchForm.keyword"
                  placeholder="请输入房屋信息"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item label="微信名称" prop="wxName" style="width: 80%">
                <el-input
                  v-model="searchForm.wxName"
                  placeholder="请输入微信名称"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="姓名" prop="userName" style="width: 80%">
                <el-input
                  v-model="searchForm.userName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="联系人号码"
                prop="phone"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.phone"
                  placeholder="请输入联系人号码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px;margin-left:15px;"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >     
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px; display: flex; align-items: center">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addUser"
          style="width: 90px"
          >新增</el-button
        >
        <el-button size="small" type="primary" @click="sendMessage">站内信</el-button>
        <!-- <el-button
          size="small"
          type="primary"
          style="width: 90px; margin-right: 15px"
          icon="el-icon-download"
        >
          <a :href="baseUrL" download style="color: #fff"
            >下载模板</a
          ></el-button
        >
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action=""
          :http-request="handleUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :show-file-list="false"
        >
          <el-button
            size="small"
            type="primary"
            icon="el-icon-upload2"
          >
            导入信息
          </el-button>
        </el-upload> -->
             
      </div>

      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="userName" label="姓名" align="center">
        </el-table-column>
        <!-- <el-table-column prop="wxName" label="微信名称" align="center">
        </el-table-column> -->
        <el-table-column
          prop="identity"
          label="性别"
          align="center"
          :formatter="sexStatus"
        >
        </el-table-column>
        <el-table-column prop="phone" label="联系方式" align="center">
        </el-table-column>
        <el-table-column
          prop="isProperty"
          label="是否物业"
          align="center"
          :formatter="oldStatus"
        >
        </el-table-column>
        <el-table-column prop="integrals" label="积分数量" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="	创建时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="用户状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="seeRoomList(scope.row)"
              >查看房间</el-button
            >
            <el-button type="text" size="small" @click="addOrSub(scope.row)"
              >加减积分</el-button
            >
            <el-button type="text" size="small" @click="updata(scope.row)"
              >修改</el-button
            >
            <!-- <el-button
              type="text"
              size="small"
              @click="binding(scope.row)"
              >绑定人员</el-button
            > -->
            <el-button type="text" size="small" @click="bindRoom(scope.row)"
              >绑定房间</el-button
            >
            <el-button type="text" size="small" @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="modalTitle"
        :visible.sync="isAddModal"
        width="50%"
        :close-on-click-modal="false"
        @close="close"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="userName">
                <el-input
                  v-model="addData.userName"
                  placeholder="请输入姓名"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phone">
                <el-input
                  v-model="addData.phone"
                  placeholder="请输入手机号码"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col>
              <el-form-item label="身份证号" prop="idCard" v-if="addData.isGeneral == -1">
                <el-input
                  v-model="addData.idCard"
                  placeholder="请输入身份证号"
                  maxlength="50"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属社区" v-if="addData.isGeneral == 1">
                <el-input
                  v-model="addData.community"
                  placeholder="请输入所属社区"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-select clearable filterable v-model="addData.sex" placeholder="请选择">
                  <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="status">
                <el-select
                  v-model="addData.status"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="modalTitle == '新增'">
            <el-row>
              <el-col :span="12">
                <el-form-item label="楼栋信息" prop="ridgepoleId">
                  <el-select
                    v-model="addData.ridgepoleId"
                    clearable filterable
                    placeholder="请选择"
                    @change="ridgepoleSelect"
                  >
                    <el-option
                      v-for="item in ridgepoleList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单元信息" prop="unitId">
                  <el-select
                    v-model="addData.unitId"
                    clearable filterable
                    placeholder="请选择"
                    @change="unitSelect"
                  >
                    <el-option
                      v-for="item in unitList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="addData.unitId">
              <el-col :span="12">
                <el-form-item label="楼层信息" prop="floorId">
                  <el-select
                    v-model="addData.floorId"
                    clearable filterable
                    placeholder="请选择"
                    @change="floorSelect"
                  >
                    <el-option
                      v-for="item in floorList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="房间信息" prop="roomId">
                  <el-select
                    v-model="addData.roomId"
                    clearable filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in roomList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份" prop="userType">
                  <el-select
                    v-model="addData.userType"
                    clearable filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in identityList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12" v-if="addData.userType == 1">
                <el-form-item label="与户主关系" label-width="100px">
                  <el-input
                    v-model="addData.identity"
                    placeholder="请输入关系"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
          </template>

          <el-row>
            <el-col :span="12">
              <el-form-item label="是否物业" prop="isProperty">
                <el-select
                  v-model="addData.isProperty"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in oldList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12" v-if="addData.isOldster == 1">
              <el-form-item label="老人描述" prop="oldsterDes">
                <el-input
                  type="textarea"
                  v-model="addData.oldsterDes"
                  placeholder="请输入老人描述"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 绑定模态框 -->
      <el-dialog
        title="绑定人员"
        :visible.sync="isAddModals"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="bindForm"
          :model="bindData"
          label-width="90px"
          :rules="bindRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" label-width="100px" prop="userName">
                <el-input
                  v-model="bindData.userName"
                  placeholder="请输入姓名"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" label-width="100px" prop="phone">
                <el-input
                  v-model="bindData.phone"
                  placeholder="请输入联系方式"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="身份" label-width="100px" prop="userName">
                <el-select
                  v-model="bindData.userType"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in identityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" label-width="100px" prop="status">
                <el-select
                  v-model="bindData.status"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="与户主关系"
                label-width="100px"
                prop="userName"
              >
                <el-input
                  v-model="bindData.identity"
                  placeholder="请输入关系"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModals = false">取 消</el-button>
          <el-button type="primary" @click="bindSubmit">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 绑定房间 -->
      <el-dialog
        title="房间绑定"
        :visible.sync="isRoom"
        width="20%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="roomFrom"
          :model="roomData"
          label-width="90px"
          :rules="roomDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="楼栋信息" prop="ridgepoleId">
                <el-select
                  v-model="roomData.ridgepoleId"
                  clearable filterable
                  placeholder="请选择"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="roomData.ridgepoleId">
            <el-col :span="24">
              <el-form-item label="单元信息" prop="unitId">
                <el-select
                  v-model="roomData.unitId"
                  clearable filterable
                  placeholder="请选择"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="roomData.unitId">
            <el-col :span="24">
              <el-form-item label="楼层信息" prop="floorId">
                <el-select
                  v-model="roomData.floorId"
                  clearable filterable
                  placeholder="请选择"
                  @change="floorSelect"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="roomData.floorId">
            <el-col :span="24">
              <el-form-item label="房间信息" prop="roomId">
                <el-select
                  v-model="roomData.roomId"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in roomList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="身份" prop="userType">
                <el-select
                  v-model="roomData.userType"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in identityLists"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row v-if="roomData.userType == 1">
            <el-col :span="24">
              <el-form-item label="与户主关系" label-width="100px">
                <el-input
                  v-model="roomData.identity"
                  placeholder="请输入关系"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isRoom = false">取 消</el-button>
          <el-button
            type="primary"
            @click="bindRoomSubmit"
            :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 人员绑定房间列表 -->
      <el-dialog
        title="房间列表"
        :visible.sync="isRoomFlags"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-table :data="userRoomList" style="width: 100%" border>
          <el-table-column prop="houseNumber" label="房屋信息" align="center">
          </el-table-column>
          <el-table-column prop="userName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="phone" label="手机号码" align="center">
          </el-table-column>
          <el-table-column
            prop="userType"
            label="身份"
            align="center"
            :formatter="onlineStatus"
          >
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="relieve(scope.row)"
                >解除绑定</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isRoomFlags = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 加减积分 -->
      <el-dialog
        title="加减积分"
        :visible.sync="isAddOrSub"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-radio-group v-model="addForm.type" size="small" style="margin-bottom: 10px;margin-left: 170px;">
          <el-radio :label="1" border>加积分</el-radio>
          <el-radio :label="2" border>减积分</el-radio>
        </el-radio-group>
        <el-form
          ref="integralsFrom"
          :model="addForm"
          label-width="170px"
          :rules="integralsRules"
          label-position="center"
        >
          <el-form-item label="当前积分">
            <el-input v-model="addForm.nowIntegrals" disabled/>
          </el-form-item>
          <el-form-item label="变动项名称" prop="objectName">
            <el-input v-model="addForm.objectName" placeholder="请输入" maxlength="100"/>
          </el-form-item>
          
          <el-form-item :label="`请输入要${addForm.type == 1?'加':'减'}的积分数量`" prop="integrals">
            <!-- <el-input type="number" v-model="addForm.integrals" placeholder="请输入积分数量"></el-input> -->
            <el-input-number 
              v-model="addForm.integrals" 
              :precision="0" 
              :step="1" 
              :min="1" 
              :max="99999999"
              placeholder="请输入积分数量"
              controls-position="right"
              @change="$refs.integralsFrom.validateField('integrals')"
              @blur="$refs.integralsFrom.validateField('integrals')">
            </el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddOrSub = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addSubmit"
            :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 站内信 -->
      <el-dialog  
        title="站内信"
        :visible.sync="isSend"
        width="60%"
        @close="sendClose"
        :close-on-click-modal="false">

        <el-form
          ref="sendForm"
          :model="sendData"
          label-width="120px"
          :rules="sendRules"
          label-position="center"
        >
          <el-form-item label="消息标题" prop="title">
            <el-input v-model="sendData.title" maxlength="100" placeholder="请输入消息标题"></el-input>
          </el-form-item>
          <el-form-item label="发送类型" prop="sendType">
            <el-select clearable filterable v-model="sendData.sendType" placeholder="请选择发送类型">
              <el-option label="群发" :value="0"></el-option>
              <el-option label="私发" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="消息内容" prop="content">
            <el-input v-model="sendData.content" type="textarea" placeholder="请输入站内信消息内容" rows="5" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isSend = false">取 消</el-button>
          <el-button
            type="primary"
            @click="sendSubmit"
            :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
        room: "",
        userName: "",
        phone: "",
        unitId: "",
        floorId: "",
        keyword:""
      },
      baseUrL: "",
      modalTitle: "新增",
      isAddModals: false,
      isShowLabel: true, //修改的时候为false  无法修改账号密码
      isRoom: false,
      roleList: [], //角色信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      isSend:false,
      sendData:{
        title:'',
        sendType:'',
        content:""
      },
      sendRules: {
        title: [{ required: true, message: "请输入消息标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入站内信消息内容", trigger: "blur" }],
        sendType: [{ required: true, message: "请选择发送类型", trigger: "change" }],
      },
      multipleSelection:[],
      allSelectedItems: new Set(),
      addData: {
        id: "",
        userName: "",
        phone: "",
        identity: "",
        status: "1", //状态 1正常 -1 冻结
        ridgepoleList: "",
        userType: "",
        sex: 1,
        isProperty: 0,
        oldsterDes: "",
        idCard:''
      },
      bindData: {
        userName: "",
        phone: "",
        identity: "",
        status: "1",
        userType: "",
      },
      roomData: {
        roomId: "",
        userId: "",
        userType: "",
        identity: "",
        ridgepoleId: "",
        unitId: "",
        floorId: "",
      },
      addForm:{
        type:1,
        objectName:""
      },
      roomDataRules: {
        ridgepoleId: [
          { required: true, message: "请选择楼栋", trigger: "blur" },
        ],
        unitId: [{ required: true, message: "请选择单元", trigger: "blur" }],
        floorId: [{ required: true, message: "请选择楼层", trigger: "blur" }],
        roomId: [{ required: true, message: "请选择房间", trigger: "blur" }],
        userType: [
          { required: true, message: "请选择用户身份", trigger: "blur" },
        ],
      },
      bindRules: {
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入您的电话", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (!reg.mobile(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        identity: [{ required: true, message: "请选择身份", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      addDataRules: {
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        idCard:[{ required: true, message: "请输入身份证号", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入您的手机号码", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (!reg.mobile(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // identity: [{ required: true, message: "请选择身份", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        // ridgepoleId: [
        //   { required: true, message: "请选择楼栋", trigger: "blur" },
        // ],
        // unitId: [{ required: true, message: "请选择单元", trigger: "blur" }],
        // floorId: [{ required: true, message: "请选择楼层", trigger: "blur" }],
        // roomId: [{ required: true, message: "请选择房间", trigger: "blur" }],
        userType: [
          { required: true, message: "请选择用户身份", trigger: "blur" },
        ],
      },
      integralsRules:{
        objectName: [
          { required: true, message: "请输入变动项名称", trigger: "blur" },
        ],
        integrals: [
          { required: true, message: "请输入积分数量", trigger: "blur" },
        ],
      },
      identityList: [
        {
          value: 0,
          label: "户主",
        },
        {
          value: 1,
          label: "亲属",
        },
        {
          value: 2,
          label: "租客",
        },
        {
          value: 3,
          label: "普通用户",
        },
      ],
      identityLists: [
        {
          value: 0,
          label: "户主",
        },
        {
          value: 1,
          label: "亲属",
        },
        {
          value: 2,
          label: "租客",
        },
      ],
      sexList: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      oldList: [
        {
          value: 0,
          label: "不是",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      statusList: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: -1,
          label: "禁用",
        },
      ],
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      isRoomFlags: false,
      ridgepoleList: [],
      unitList: [],
      floorList: [],
      roomList: [],
      userRoomList: [],
      roomUserId: "",
      isAddOrSub:false,
    };
  },
  mounted() {
    this.baseUrL =
      process.env.VUE_APP_UPLOAD_REAL_PATH +
      "/user-room/batchImportTemplate?villageId=" +
      JSON.parse(localStorage.getItem("ToUserInfo")).id;
    this.onLoad();
  },
  methods: {
    sendClose(){
      this.$refs.sendForm.resetFields()
      for (let item in this.sendData) {
        this.sendData[item] = "";
      }
      this.isSend = false
    },
    sendMessage(){
      this.isSend = true
    },
    // 修改 handleSelectionChange 方法
    handleSelectionChange(val) {
      // 清除当前页所有项在 allSelectedItems 中的记录
      this.tableData.forEach(item => {
        this.allSelectedItems.delete(item.id);
      });
      
      // 将当前页选中的项添加到 allSelectedItems
      val.forEach(item => {
        this.allSelectedItems.add(item.id);
      });
      console.log(this.allSelectedItems);
      // 更新 multipleSelection 为当前选中的项
      this.multipleSelection = val;
    },
    // 添加一个方法来清除所有选中项
    clearAllSelection() {
      this.allSelectedItems.clear();
      this.multipleSelection = [];
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
    },
    sendSubmit(){
      this.$refs["sendForm"].validate((valid) => {
        if(valid){
          let ids = []
          if(this.sendData.sendType == 1){
            if (this.allSelectedItems.size == 0) {
              this.$message.error('请选择发送用户！')
              return
            }
            
          }
          this.btnLoading = true
          let data = {
            content:this.sendData.content,
            messageType:0,
            sendType:this.sendData.sendType,
            target:1,
            title:this.sendData.title
          }
          if(this.sendData.sendType == 1){
            data.userId = Array.from(this.allSelectedItems).join(',')
          }
          this.$Apis.messageAdd(data).then(res=>{
            this.btnLoading = false
            if(res.code == 200){
              this.clearAllSelection()
              this.isSend = false
              this.$message.success("发送成功")   
            }
          })
        }
      })
      
    },




    addOrSub(row){
      this.isAddOrSub = true
      this.addForm = {
        type:1,
        nowIntegrals:row.integrals,
        userId:row.id
      }
      this.$refs["integralsFrom"].resetFields()
    },
    addSubmit(){
      this.$refs["integralsFrom"].validate((valid) => {

        if (valid) {
          if(this.addForm.type == 2 && this.addForm.integrals > this.addForm.nowIntegrals){
            this.$message.warning("减掉积分不能大于当前积分")
            return
          }
          this.btnLoading = true;
          var data = {
            sourceType:1,
            userId:this.addForm.userId,
            integrals:this.addForm.integrals,
            objectName:this.addForm.objectName,
            type:this.addForm.type
          };
          this.$Apis.userIntegralsRecordUpdIntegrals(data).then((res) => {
            this.btnLoading = false;
            if (res.code == 200) {
              this.isAddOrSub = false;
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 房间信息导入
    handleUpload({ file }) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        var formData = new FormData();
        formData.append("file", file);
        formData.append(
          "villageId",
          JSON.parse(localStorage.getItem("park_data")).id
        );
        this.$Apis.roomBatchImport(formData).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
          loading.close();
        });
      } catch (error) {
        loading.close();
      }
    },
    handlePreview() {},
    handleRemove() {},
    // 选择楼栋
    ridgepoleSelect(e) {
      this.searchForm.unitId = "";
      this.searchForm.floorId = "";
      this.addData.unitId = ''
      this.addData.floorId = ''
      this.roomData.unitId = ''
      this.roomData.floorId = ''
      this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
        if (res.code == 200) {
          this.unitList = res.data;
        }
      });
    },
    // 选择单元
    unitSelect(e, row) {
      this.$Apis.floorAllList({ unitId: e }).then((res) => {
        if (res.code == 200) {
          this.floorList = res.data;
          this.searchForm.floorId = "";
          if (row == "updata") {
            this.isAddModal = true;
          }
        }
      });
    },
    // 解除绑定
    relieve(row) {
      this.$confirm("您确定要解除绑定的房间吗？, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.roombindDel({ id: row.id }).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.roombindRoomList();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    roombindRoomList() {
      var data = {
        current: 1,
        size: 20,
        userId: this.roomUserId,
      };
      this.$Apis.roombindRoomList(data).then((res) => {
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.isRoomFlags = true;
          this.userRoomList = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 查看房间列表
    seeRoomList(row) {
      this.roomUserId = row.id;
      this.roombindRoomList();
    },
    // 选择楼层
    floorSelect(e) {
      this.$Apis.roomAllList({ floorId: e }).then((res) => {
        if (res.code == 200) {
          this.roomList = res.data;
        }
      });
    },
    // 绑定房间
    bindRoom(row) {
      this.isRoom = true;
      for (let item in this.roomData) {
        this.roomData[item] = "";
      }
      this.$nextTick(()=>{
        this.$refs["roomFrom"].resetFields()
      })
      
      this.roomData.userId = row.id;
    },
    // 绑定人员
    binding() {
      for (let item in this.bindData) {
        this.bindData[item] = "";
      }
      this.isAddModals = true;
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.clearAllSelection(); 
      this.onLoad();
    },
    //   删除用户
    del(row) {
      this.$confirm("您确定要删除该用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.userDel({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.userUpdateStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    onlineStatus(row) {
      if (row.userType == 0) {
        return "户主";
      } else if (row.userType == 1) {
        return "亲属";
      } else if (row.userType == 2) {
        return "租客";
      } else if (row.userType == 3) {
        return "普通用户";
      }
    },
    oldStatus(row) {
      if (row.isProperty == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    sexStatus(row) {
      if (row.sex == 1) {
        return "男";
      } else {
        return "女";
      }
    },
    // 新增用户
    addUser() {
      this.modalTitle = "新增";
      this.isAddModal = true;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.isProperty = 0;
    },
    updata(row) {
      this.modalTitle = "修改";
      this.isAddModal = true;
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.isProperty = Number(this.addData.isProperty);
      this.addData.status = this.addData.status == true ? 1 : -1;
    },
    bindRoomSubmit() {
      this.$refs["roomFrom"].validate((valid) => {
        if (valid) {
          var data = {
            roomId: this.roomData.roomId,
            userId: this.roomData.userId,
            userType: this.roomData.userType,
            identity: this.roomData.identity,
          };
          this.$Apis.roombind(data).then((res) => {
            if (res.code == 200) {
              this.isRoom = false;
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    bindSubmit() {
      this.$refs["bindForm"].validate((valid) => {
        if (valid) {
          this.onsubmit();
        }
      });
    },
    onsubmit() {
      let data = {
        id: this.addData.id || "",
        userName: this.addData.userName,
        status: this.addData.status,
        sex: this.addData.sex,
        userType: this.addData.userType || "",
        phone: this.addData.phone,
        // identity: this.addData.identity || "",
        roomId: this.addData.roomId || "",
        userId: this.addData.id || "",
        isProperty: this.addData.isProperty,
        oldsterDes: this.addData.oldsterDes,
        idCard: this.addData.idCard || "",
        community: this.addData.community,
      };
      this.$Apis.userUpdata(data).then((res) => {
        this.btnLoading = false;
        if (res.code == 200) {
          // if (this.modalTitle == "修改") {
            this.isAddModal = false;
            this.isAddModals = false;
            this.onLoad();
            this.$message.success("操作成功");
          // } else {
          //   var date = {
          //     roomId: this.addData.roomId,
          //     userId: res.data,
          //     userType: this.addData.userType,
          //     identity: this.addData.identity,
          //   };
          //   this.$Apis.roombind(date).then((res) => {
          //     if (res.code == 200) {
          //       this.isAddModal = false;
          //       this.isAddModals = false;
          //       this.onLoad();
          //       this.$message.success("操作成功");
          //     } else {
          //       this.$message.warning(res.msg);
          //     }
          //   });
          // }
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 提交
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.onsubmit();
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.currentPage = ind == 1 ? 1 : this.currentPage;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      
      this.$Apis.houseAllList().then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
        }
      });
      
      this.$Apis.getCharacterList().then((res) => {
        if (res.code == 200) {
          let { list } = res.data;
          this.roleList = list;
        }
      });
      
      this.$Apis.userList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item) => {
            item.status = item.status == 1 ? true : false;
            // 检查该项是否在 allSelectedItems 中，如果是则标记为选中
            item.selected = this.allSelectedItems.has(item.id);
          });
          
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          
          // 在 DOM 更新后设置表格的选中状态
          this.$nextTick(() => {
            // 清除当前表格选中状态
            this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
            // 重新设置当前页的选中项
            list.forEach(item => {
              if (item.selected) {
                this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(item, true);
              }
            });
          });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style  scoped>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
/deep/.el-upload-list {
  display: none;
}
</style>
